function pauseAllMedia() {
  const videoPlayers = document.querySelectorAll(
    ".l-courses__video-wrapper iframe",
  );
  videoPlayers.forEach((player) => {
    // Can only do this if the video is a Vimeo video
    if (player.src.includes("vimeo.com")) {
      const vimeoPlayer = new Vimeo.Player(player);
      vimeoPlayer.pause();
    }
  });

  // Pause all audio players when a tab is clicked
  const audioPlayers = document.querySelectorAll(".l-courses__audio-player");
  audioPlayers.forEach((player) => {
    //Pause the player
    const audioEl = player.querySelector(".tbp-audio");
    audioEl.pause();

    // Change the icon back to the play icon
    var playButton = player.querySelector(".tbp-audio-player__button-play");
    var playSVG = playButton.querySelector(".play");
    var pauseSVG = playButton.querySelector(".pause");
    playSVG.style.display = "block";
    pauseSVG.style.display = "none";
  });
}

jQuery(document).ready(function ($) {
  $(".js-tbp-accordion").accordionjs({
    closeAble: true,
    beforeOpenSection: function (section) {
      section.find(".c-accordion__show-hide-text").text("Hide");
      section.find(".c-accordion__show-hide-icon_minus").addClass("show");
      section.find(".c-accordion__show-hide-icon_plus").removeClass("show");
    },
    beforeCloseSection: function (section) {
      section.find(".c-accordion__show-hide-text").text("Show");
      section.find(".c-accordion__show-hide-icon_minus").removeClass("show");
      section.find(".c-accordion__show-hide-icon_plus").addClass("show");
      pauseAllMedia();
    },
  });

  const lessonTabs = document.querySelector("[data-tabs]");
  if (lessonTabs) {
    var tabs = new Tabby("[data-tabs]");
  }

  const mediationTabs = document.querySelector("[medi-data-tabs]");
  if (mediationTabs) {
    var mediTabs = new Tabby("[medi-data-tabs]");
  }

  document.addEventListener("tabby", function () {
    // Uses player.js to pause all Vimeo videos when a tab is clicked
    pauseAllMedia();
  });
});
